/**
 * Script-tag / CDN entry. Builds to a self-installing IIFE that puts the API on
 * `window.Quarterzip` and drains any commands queued by an async loader stub.
 *
 * ESM consumers should import from the package root instead; this file is only for `<script>` use.
 */
import { close, closePip, configure, open, openPip } from './index';
import type { QuarterzipAPI } from './types';

const install = (): void => {
	if (window._quarterzipLoaded) return;
	window._quarterzipLoaded = true;

	const stub = window.Quarterzip as QuarterzipAPI | undefined;
	const queue = stub?._q ?? [];

	// A queued openPip() replays here outside a user gesture and is refused by the browser. That is
	// the integrator's call to make from their own click handler.
	const api: QuarterzipAPI = { open, close, configure, openPip, closePip, _q: [] };
	window.Quarterzip = api;

	for (const [method, callArgs] of queue) {
		const fn = api[method];
		if (typeof fn === 'function') {
			(fn as (...a: unknown[]) => unknown)(...callArgs);
		}
	}
};

install();
